export enum RolesWeCumplimento {
    AdminWecCumplimiento = 1009,
    EjecutivoWecCumplimiento = 1010,
    ClienteWecCumplimiento = 1011,
    LiderWeCumplimiento = 1012,
}